import React from 'react';
import Book from './images/book.module.svg';
import BlackBoard from './images/blackBoard.module.svg';
import Burger from './images/burger.module.svg';
import Eye from './images/eye.module.svg';
import Email from './images/email.module.svg';
import Sort from './images/sort.module.svg';
import Unsort from './images/unsort.module.svg';
import Person from './images/person.module.svg';
import Diamond from './images/diamond.module.svg';
import DiamondFIlled from './images/diamondFilled.module.svg';
import DiamondSolid from './images/diamondSolid.module.svg';
import InfoInverse from './images/infoInverse.module.svg';
import List from './images/list.module.svg';
import Login from './images/login.module.svg';
import Logout from './images/logout.module.svg';
import Fire from './images/fire.module.svg';
import Camps from './images/camps.module.svg';
import Cart from './images/cart.module.svg';
import Clock from './images/clock.module.svg';
import ClockFilled from './images/clockFilled.module.svg';
import Courses from './images/courses.module.svg';
import Discount from './images/discount.module.svg';
import Externat from './images/externat.module.svg';
import Headphones from './images/headphones.module.svg';
import PriceTag from './images/priceTag.module.svg';
import Prof from './images/prof.module.svg';
import Phone from './images/phone.module.svg';
import Star from './images/star.module.svg';
import Settings from './images/settings.module.svg';
import Student from './images/student.module.svg';
import Target from './images/target.module.svg';
import Textbook from './images/textbook.module.svg';
import Trophy from './images/trophy.module.svg';
import Message from './images/message.module.svg';
import Wallet from './images/wallet.module.svg';
import Edit from './images/edit.module.svg';
import Copy from './images/copy.module.svg';
import Page from './images/page.module.svg';
import Print from './images/print.module.svg';
import Objective from './images/objective.module.svg';
import Present from './images/present.module.svg';
export var book =
/*#__PURE__*/
Book();
export var blackBoard =
/*#__PURE__*/
BlackBoard();
export var burger =
/*#__PURE__*/
Burger();
export var eye =
/*#__PURE__*/
Eye();
export var email =
/*#__PURE__*/
Email();
export var sort =
/*#__PURE__*/
Sort();
export var unsort =
/*#__PURE__*/
Unsort();
export var person =
/*#__PURE__*/
Person();
export var diamond =
/*#__PURE__*/
Diamond();
export var diamondFilled =
/*#__PURE__*/
DiamondFIlled();
export var diamondSolid =
/*#__PURE__*/
DiamondSolid();
export var infoInverse =
/*#__PURE__*/
InfoInverse();
export var list =
/*#__PURE__*/
List();
export var login =
/*#__PURE__*/
Login();
export var logout =
/*#__PURE__*/
Logout();
export var fire =
/*#__PURE__*/
Fire();
export var camps =
/*#__PURE__*/
Camps();
export var cart =
/*#__PURE__*/
Cart();
export var clock =
/*#__PURE__*/
Clock();
export var clockFilled =
/*#__PURE__*/
ClockFilled();
export var courses =
/*#__PURE__*/
Courses();
export var discount =
/*#__PURE__*/
Discount();
export var externat =
/*#__PURE__*/
Externat();
export var headphones =
/*#__PURE__*/
Headphones();
export var page =
/*#__PURE__*/
Page();
export var priceTag =
/*#__PURE__*/
PriceTag();
export var phone =
/*#__PURE__*/
Phone();
export var prof =
/*#__PURE__*/
Prof();
export var star =
/*#__PURE__*/
Star();
export var settings =
/*#__PURE__*/
Settings();
export var student =
/*#__PURE__*/
Student();
export var target =
/*#__PURE__*/
Target();
export var textbook =
/*#__PURE__*/
Textbook();
export var trophy =
/*#__PURE__*/
Trophy();
export var message =
/*#__PURE__*/
Message();
export var wallet =
/*#__PURE__*/
Wallet();
export var edit =
/*#__PURE__*/
Edit();
export var copy =
/*#__PURE__*/
Copy();
export var print =
/*#__PURE__*/
Print();
export var objective =
/*#__PURE__*/
Objective();
export var present =
/*#__PURE__*/
Present();
export var calendar =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20",
  viewBox: "0 0 21 20"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M.8 19.8h19.4c.4 0 .7-.3.7-.7V2.4a.7.7 0 0 0-.8-.8h-3.7V1A.7.7 0 1 0 15 1v.5H6V1a.7.7 0 1 0-1.4 0v.5H.8a.7.7 0 0 0-.7.8V19c0 .5.4.8.8.8zM1.5 3h3v.5a.7.7 0 1 0 1.5 0V3h9v.5a.7.7 0 1 0 1.5 0V3h3v2h-18V3zm0 3.5h18v12h-18v-12z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M15.8 10H5.2a.7.7 0 0 0-.7.7c0 .4.3.8.7.8h10.6c.4 0 .7-.4.7-.8a.7.7 0 0 0-.7-.8zm-5.3 3.6H5.2a.7.7 0 0 0-.7.7c0 .5.3.8.7.8h5.3c.4 0 .7-.2.7-.7a.7.7 0 0 0-.7-.7z"
}));
export var calendar_simple =
/*#__PURE__*/
React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M13 2V0H11V2H5V0H3V2H0V4V5V16H16V5V4V2H13ZM14 14H2V6H14V14Z"
}));
export var chevronDown =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "13",
  viewBox: "0 0 21 13"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M10.109 10.604l-7.74-8.297a1.42 1.42 0 0 1 0-1.911 1.201 1.201 0 0 1 1.783 0l6.848 7.342 6.848-7.342a1.202 1.202 0 0 1 1.783 0 1.421 1.421 0 0 1 0 1.911l-7.74 8.297a1.214 1.214 0 0 1-.89.396c-.323 0-.646-.132-.892-.396z"
}));
export var chevronUp =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "13",
  viewBox: "0 0 21 13"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M10.109 1.396l-7.74 8.297a1.42 1.42 0 0 0 0 1.911c.493.528 1.29.528 1.783 0l6.848-7.342 6.848 7.342c.492.528 1.29.528 1.783 0a1.421 1.421 0 0 0 0-1.911l-7.74-8.297a1.214 1.214 0 0 0-.89-.396c-.323 0-.646.132-.892.396z"
}));
export var chevronRight =
/*#__PURE__*/
React.createElement("svg", {
  width: "8",
  height: "14",
  viewBox: "0 0 8 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M0 1.87054L1.39309 0.5L8 7L1.39309 13.5L0 12.1295L5.21383 7L0 1.87054Z"
}));
export var chevronLeft =
/*#__PURE__*/
React.createElement("svg", {
  width: "8",
  height: "14",
  viewBox: "0 0 8 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M8 12.1295L6.60691 13.5L0 7L6.60691 0.5L8 1.87054L2.78617 7L8 12.1295Z"
}));
export var cross =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M17.333.668a1.845 1.845 0 0 0-2.61 0l-5.723 5.722-5.723-5.722a1.845 1.845 0 1 0-2.61 2.61l5.723 5.723-5.723 5.724a1.845 1.845 0 1 0 2.61 2.61l5.723-5.723 5.723 5.723c.36.36.832.54 1.305.54a1.845 1.845 0 0 0 1.305-3.151l-5.723-5.721 5.723-5.724a1.845 1.845 0 0 0 0-2.61z"
}));
export var dialog =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M3.66 3.664a12.422 12.422 0 0 1 8.84-3.664c3.342 0 6.48 1.303 8.841 3.664 4.556 4.554 4.886 11.83.828 16.761.56 1.146 1.22 1.91 1.969 2.277.455.225.712.717.639 1.22a1.16 1.16 0 0 1-.974.979 5.953 5.953 0 0 1-.886.068c-1.534 0-3.147-.53-4.493-1.456a12.52 12.52 0 0 1-5.923 1.487 12.417 12.417 0 0 1-8.84-3.659 12.414 12.414 0 0 1-3.661-8.836c0-3.334 1.299-6.48 3.66-8.84zm1.001 16.672a11.02 11.02 0 0 0 7.84 3.245c1.98 0 3.922-.528 5.614-1.523.11-.063.236-.1.356-.1.152 0 .31.053.435.147 1.602 1.24 3.215 1.424 3.922 1.44-.843-.628-1.55-1.602-2.142-2.958a.711.711 0 0 1 .12-.753c3.876-4.377 3.672-11.045-.465-15.18a11.02 11.02 0 0 0-7.84-3.246 11.02 11.02 0 0 0-7.84 3.245c-4.326 4.33-4.326 11.365 0 15.683zM7.581 8.125h10.463c.392 0 .706.278.706.625s-.314.625-.706.625h-10.464c-.392 0-.706-.278-.706-.625s.32-.625.706-.625zm0 3.875h10.463c.392 0 .706.278.706.625s-.314.625-.706.625h-10.464c-.392 0-.706-.278-.706-.625s.32-.625.706-.625zm0 4h10.463c.392 0 .706.278.706.625s-.314.625-.706.625h-10.464c-.392 0-.706-.278-.706-.625s.32-.625.706-.625z"
}));
export var dropDownArrow =
/*#__PURE__*/
React.createElement("svg", {
  width: "11",
  height: "7",
  viewBox: "0 0 11 7"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M4.288 5.703l.117.139c.393.393.973.441 1.302.112l.009-.009.123-.105.104-.122 4.015-4.015c.38-.38.384-1.017-.007-1.408-.393-.393-1.025-.389-1.417.002l-3.412 3.412-3.419-3.419c-.388-.388-1.016-.388-1.409.005-.391.391-.393 1.021-.005 1.409l3.999 3.999z"
}));
export var externalLink =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  enableBackground: "new 0 0 16 16"
},
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M0 0h16v16h-16z",
  fillOpacity: "0"
}),
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M9 0v2h3.6l-7.3 7.3 1.4 1.4 7.3-7.3v3.6h2v-7zM14 14h-12v-12h4v-2h-6v16h16v-6h-2z"
}));
export var file =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "20",
  viewBox: "0 0 17 20"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M16.734 5.931c-.176-.416-.388-.745-.636-.988l-4.138-4.059c-.247-.242-.583-.45-1.007-.624-.425-.173-.814-.26-1.167-.26h-8.488a1.24 1.24 0 0 0-.901.364 1.192 1.192 0 0 0-.372.885v17.481c0 .347.124.642.372.885.247.242.548.364.901.364h14.429c.353 0 .654-.122.901-.364.248-.243.371-.538.371-.885v-11.654c0-.347-.088-.729-.265-1.145zm-6.524-4.161c.256.087.437.182.544.286l4.15 4.071c.106.104.204.282.292.534h-4.986v-4.892zm5.092 16.545h-13.58v-16.651h6.79v5.412c0 .347.124.642.372.884.247.243.548.365.901.365h5.517v9.989z"
}));
export var fileBordered =
/*#__PURE__*/
React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M8.3 0H6H0V16H13H16V0H8.3ZM8 2.5L10.5 5H8V2.5ZM2 14V2H6V7H11V14H2ZM14 14H13V7V4.7L10.3 2H14V14Z"
}));
export var lessons =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "16",
  viewBox: "0 0 22 16"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M21.8 8.4a1.8 1.8 0 0 0-.8-.8 2.4 2.4 0 0 0-1-.3h-2.3V5.5c0-.7-.3-1.3-.8-1.8a2.5 2.5 0 0 0-2-.8H9v-.4c0-.7-.2-1.3-.7-1.8A2.5 2.5 0 0 0 6.4 0H2.6C2 0 1.3.3.8.8S0 1.8 0 2.6v10.8c0 .7.3 1.3.8 1.8a2.5 2.5 0 0 0 1.8.8H15c.6 0 1 0 1.7-.4.6-.3 1-.6 1.3-1l3.4-4c.4-.6.6-1 .6-1.5a1.8 1.8 0 0 0-.2-.6zM1.5 2.6c0-.3 0-.6.3-.8.2-.2.5-.3.8-.3h3.7c.3 0 .5 0 .7.3.3.2.4.5.4.8v.7c0 .3 0 .5.3.8.2.3.5.4.8.4H15c.4 0 .7 0 1 .3l.2.8v1.8H7.4c-.6 0-1 0-1.6.4s-1 .6-1.4 1l-3 3.5V2.6zm18.8 7l-3.4 4-1 .7-1 .2H2.7c-.4 0-.6 0-.6-.4l.2-.3 3.4-4c.2-.4.4-.6.8-.7.3-.2.7-.3 1-.3H20c.3 0 .5.2.5.4 0 .3 0 .4-.2.6z"
}));
export var pencil =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  viewBox: "0 0 19 19"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M17.863 5.258l-4.113-4.122.283-.283a2.9 2.9 0 0 1 4.113.005 2.909 2.909 0 0 1 0 4.117l-.283.283zm-5.388-2.847l4.118 4.117-11.553 11.551-5.04.921.92-5.038 11.556-11.551z"
}));
export var phoneNoFill =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M25.28 19.815c-.655-.682-1.445-1.047-2.282-1.047-.83 0-1.627.358-2.309 1.04l-2.133 2.127-.52-.27a8.579 8.579 0 0 1-.669-.358c-1.998-1.27-3.814-2.923-5.556-5.064-.844-1.066-1.41-1.964-1.822-2.876.553-.506 1.066-1.032 1.566-1.539l.567-.574c1.418-1.417 1.418-3.254 0-4.671l-1.843-1.843c-.21-.21-.425-.426-.628-.642-.405-.418-.83-.85-1.27-1.255-.654-.649-1.437-.993-2.26-.993-.824 0-1.621.344-2.296.993l-.014.013-2.295 2.316a4.94 4.94 0 0 0-1.465 3.138c-.162 1.971.419 3.808.864 5.01 1.094 2.95 2.728 5.684 5.165 8.614 2.957 3.53 6.514 6.319 10.579 8.283 1.552.736 3.625 1.607 5.94 1.755l.426.014c1.56 0 2.87-.56 3.895-1.674l.027-.034c.351-.425.756-.81 1.182-1.222.29-.277.587-.567.877-.87.669-.696 1.02-1.506 1.02-2.337 0-.837-.358-1.64-1.04-2.315l-3.706-3.72zm1.595 6.857c-.227.245-.46.465-.71.71-.377.36-.76.738-1.121 1.163-.588.628-1.28.924-2.187.924l-.267-.006c-1.727-.11-3.378-.572-4.581-1.148-1.565-.757-6.166-3.373-9.24-6.667-3.39-3.633-5.311-8.135-5.772-9.379a8.219 8.219 0 0 1-.51-3.704 2.67 2.67 0 0 1 .802-1.727l1.983-1.983c.285-.268.587-.413.884-.413.366 0 .663.22.849.407.372.349.71.692 1.064 1.058l.552.564 1.589 1.589c.616.616.616 1.186 0 1.802l-.5.5c-.489.5-1.206 1.178-1.712 1.631-.53.53-.436 1.018-.331 1.35.242.596 1.767 3.576 3.98 5.982 1.856 2.017 4.38 3.504 5.231 4.042.239.152.483.274.715.39.21.105.407.203.576.308l.07.04c.198.1.384.146.576.146.482 0 .785-.302.883-.401l2.241-2.2c.198-.198.512-.437.878-.437.361 0 .658.227.838.425l3.215 3.215c.6.593.6 1.204.006 1.82zm-9.589-19.063a8.56 8.56 0 0 1 4.659 2.417 8.606 8.606 0 0 1 2.417 4.658c.074.446.459.756.897.756l.156-.013c.5-.081.83-.554.75-1.054a10.413 10.413 0 0 0-2.924-5.637 10.413 10.413 0 0 0-5.637-2.923.916.916 0 0 0-1.053.743.902.902 0 0 0 .735 1.053zm14.664 6.501a17.13 17.13 0 0 0-4.814-9.283 17.13 17.13 0 0 0-9.282-4.813.908.908 0 0 0-1.047.743c-.08.5.25.965.75 1.053 3.146.533 6.015 2.025 8.297 4.3a15.294 15.294 0 0 1 4.3 8.297c.074.446.46.756.898.756a.894.894 0 0 0 .898-1.053z"
}));
export var radioChecked =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
},
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 5c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0-5c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
}));
export var radioNotChecked =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
},
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 0c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
}));
export var search =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "29",
  height: "30",
  viewBox: "0 0 29 30"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M28.6 27.3l-7-7.4a12.2 12.2 0 0 0 2.7-8c0-6.6-5.3-12-12-12C6 0 .6 5.4.6 12c0 6.8 5.4 12.2 12 12.2 2.4 0 4.7-.7 6.7-2.2l7 7.5a1.5 1.5 0 0 0 2.3 0 1.6 1.6 0 0 0 0-2.2zm-16.2-24c5 0 8.8 4 8.8 8.8 0 5-4 9-8.8 9s-8.8-4-8.8-9c0-4.8 4-8.8 8.8-8.8z"
}));
export var tasks =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "20",
  viewBox: "0 0 18 20"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M17.2 2H13V.8c0-.4-.3-.7-.7-.7H5.8c-.5 0-.8.3-.8.7v4c0 .3.3.6.8.6h4.8c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-4V1.4h5V3c0 .3.2.6.7.6h4v15H1.7v-15h1.2c.4 0 .8-.3.8-.7 0-.5-.4-1-.8-1h-2C.4 2 0 2.6 0 3v16.3c0 .4.4.7.8.7h16.4c.4 0 .8-.3.8-.8V3c0-.5-.4-1-.8-1z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M12.6 9a.8.8 0 0 0-1 0l-3.7 3.3L6.4 11a.8.8 0 0 0-1 0 .7.7 0 0 0 0 1l1.8 1.8c.2.2.4.2.6.2 0 0 .3 0 .4-.2l4.2-4a.7.7 0 0 0 0-1z"
}));
export var tinyCross =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  viewBox: "0 0 26 26"
},
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.7 12.8L1 22.4c-.5.6-.5 1.6 0 2.2.8.6 1.7.6 2.3 0L13 15l9.5 9.6c.6.6 1.6.6 2.2 0 .6-.6.6-1.6 0-2.2L15 12.8l9.6-9.5c.6-.6.6-1.6 0-2.2-.6-.5-1.6-.5-2.2 0L13 10.7 3.3 1C2.8.6 1.8.6 1.2 1c-.6.7-.6 1.7 0 2.3l9.5 9.5z"
}));
export var sharpCross =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M8 6.53l6.53-6.53 1.47 1.47-6.53 6.53 6.53 6.53-1.47 1.47-6.53-6.53-6.53 6.53-1.47-1.47 6.53-6.53-6.53-6.53 1.47-1.47z"
}));
export var plus =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "19",
  viewBox: "0 0 18 19"
},
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
},
/*#__PURE__*/
React.createElement("rect", {
  width: "18",
  height: "3",
  y: "8",
  rx: "1.5"
}),
/*#__PURE__*/
React.createElement("rect", {
  width: "18",
  height: "3",
  y: "8",
  rx: "1.5",
  transform: "rotate(90 9 9.5)"
})));
export var plusThin =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14"
},
/*#__PURE__*/
React.createElement("path", {
  fillRule: "nonzero",
  d: "M7.875 6.125H14v1.75H7.875V14h-1.75V7.875H0v-1.75h6.125V0h1.75v6.125z"
}));
export var play =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M28.197 7.501c-4.173-7.173-13.414-9.63-20.64-5.489-7.227 4.141-9.703 13.314-5.53 20.486 4.172 7.174 13.413 9.632 20.639 5.49 7.227-4.142 9.704-13.314 5.53-20.487zm-7.042 17.889c-5.78 3.313-13.173 1.347-16.511-4.392-3.338-5.738-1.357-13.076 4.424-16.388 5.78-3.314 13.174-1.348 16.512 4.39 3.337 5.74 1.356 13.077-4.425 16.39zm-.604-11l-7.911-4.58c-.72-.418-1.302-.084-1.298.744l.04 9.091c.004.828.593 1.165 1.316.75l7.851-4.499c.722-.414.724-1.088.003-1.506z"
}));
export var reload =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "20",
  viewBox: "0 0 19 20"
},
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M1.638 8.346c.653 0 1.243-.386 1.495-.978a6.896 6.896 0 0 1 6.351-4.164c1.575 0 3.019.53 4.176 1.412l-.907.138a.702.702 0 0 0-.593.594.694.694 0 0 0 .411.729l4.99 2.208a.72.72 0 0 0 .673-.05.695.695 0 0 0 .325-.582l.026-5.408a.697.697 0 0 0-.501-.669.714.714 0 0 0-.796.28L16.6 2.873A10.202 10.202 0 0 0 9.484 0C5.284 0 1.672 2.523.132 6.109a1.586 1.586 0 0 0 .143 1.516c.303.45.815.72 1.363.72zM18.693 12.344a1.643 1.643 0 0 0-1.364-.721c-.652 0-1.242.385-1.494.977a6.896 6.896 0 0 1-6.351 4.165 6.872 6.872 0 0 1-4.176-1.412l.907-.138a.702.702 0 0 0 .593-.595.694.694 0 0 0-.411-.728l-4.99-2.208a.72.72 0 0 0-.673.05.695.695 0 0 0-.325.582l-.026 5.407a.697.697 0 0 0 .501.67c.3.09.623-.025.796-.28l.688-1.017a10.201 10.201 0 0 0 7.116 2.872c4.2 0 7.812-2.523 9.352-6.109a1.586 1.586 0 0 0-.143-1.515z"
})));
export var checkCircle =
/*#__PURE__*/
React.createElement("svg", {
  height: "14",
  viewBox: "0 0 14 14",
  width: "14",
  xmlns: "http://www.w3.org/2000/svg"
},
/*#__PURE__*/
React.createElement("path", {
  d: "m4.13 5.67-.98.98 3.15 3.15 7-7-.98-.98-6.02 6.02zm8.47 1.33c0 3.08-2.52 5.6-5.6 5.6s-5.6-2.52-5.6-5.6 2.52-5.6 5.6-5.6c.56 0 1.05.07 1.54.21l1.12-1.12c-.84-.28-1.75-.49-2.66-.49-3.85 0-7 3.15-7 7s3.15 7 7 7 7-3.15 7-7z"
}));
export var info =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
},
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.986 6.995v-2.019h-1.972v2.02h1.972zm0 8.029v-6.01h-1.972v6.01h1.972zm-.986-15.024c1.827 0 3.518.457 5.072 1.37a9.478 9.478 0 0 1 3.558 3.558 9.835 9.835 0 0 1 1.37 5.072 9.835 9.835 0 0 1-1.37 5.072 9.478 9.478 0 0 1-3.558 3.558 9.835 9.835 0 0 1-5.072 1.37 9.835 9.835 0 0 1-5.072-1.37 9.657 9.657 0 0 1-3.558-3.582 9.79 9.79 0 0 1-1.37-5.048 9.79 9.79 0 0 1 1.37-5.048 9.842 9.842 0 0 1 3.582-3.582 9.79 9.79 0 0 1 5.048-1.37z"
}));
export var check =
/*#__PURE__*/
React.createElement("svg", {
  width: "20px",
  height: "20px",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
},
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-675.000000, -7517.000000)",
  fill: "#7FC92E"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(675.000000, 7517.000000)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M10,0 C15.5228475,-1.01453063e-15 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 6.76353751e-16,15.5228475 0,10 C-6.76353751e-16,4.4771525 4.4771525,1.01453063e-15 10,0 Z M14.2928932,6.29289322 L9,11.5857864 L6.70710678,9.29289322 L5.29289322,10.7071068 L9,14.4142136 L15.7071068,7.70710678 L14.2928932,6.29289322 Z"
})))));
export var home =
/*#__PURE__*/
React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
},
/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("rect", {
  width: "16",
  height: "16",
  fill: "black",
  fillOpacity: "0"
}),
/*#__PURE__*/
React.createElement("path", {
  id: "house_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 16V11H9V16H15V5L8 0L1 5V16H7ZM5 14H3V6.02917L8 2.45776L13 6.02917V14H11V9H5V14Z"
})));
export var questionFilled =
/*#__PURE__*/
React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  enableBackground: "new 0 0 20 20"
},
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  fillOpacity: "0",
  d: "M0 0h20v20h-20z"
}),
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M17.1 2.9c-1.9-1.8-4.4-2.9-7.1-2.9-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10c0-2.7-1.1-5.2-2.9-7.1zm-6.1 12.1h-2v-2h2v2zm.5-4.5c-.3.2-.6.6-.5.9v.1h-2v-.1c0-1.1.6-2.2 1.7-2.7.5-.2.8-.8.8-1.3 0-.8-.7-1.4-1.5-1.4s-1.5.6-1.5 1.4h-2c0-1.9 1.6-3.4 3.5-3.4s3.5 1.5 3.5 3.4c0 1.3-.8 2.5-2 3.1z"
}));
export var document =
/*#__PURE__*/
React.createElement("svg", {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
},
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0004 4.50038L12.4648 0.964844L5.36865 8.06104L5.39378 11.5714L8.90418 11.5966L16.0004 4.50038ZM7.37459 8.88353L12.4648 3.79327L13.172 4.50038L8.08169 9.59063L7.37961 9.58561L7.37459 8.88353Z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M13 15V10H15V17H0V2H7V4H2V15H13Z"
}));
export var cancel =
/*#__PURE__*/
React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14Z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M9.7998 4.79999L7.9998 6.59999L6.1998 4.79999L4.7998 6.19999L6.5998 7.99999L4.7998 9.79999L6.1998 11.2L7.9998 9.39999L9.7998 11.2L11.1998 9.79999L9.3998 7.99999L11.1998 6.19999L9.7998 4.79999Z"
}));
export var playPause =
/*#__PURE__*/
React.createElement("svg", {
  width: "16",
  height: "12",
  viewBox: "0 0 16 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
},
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 6L5.46341 4.68292L2 1.71429L0 0V2.63416V9.36584V12L2 10.2857L5.46341 7.31708L7 6ZM3.92682 6L2 4.34845V7.65155L3.92682 6ZM14 0H16V12H14V0ZM12 0H10V12H12V0Z"
}));
export var video =
/*#__PURE__*/
React.createElement("svg", {
  width: "16",
  height: "12",
  viewBox: "0 0 16 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
},
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 2H9V10H2V2ZM0 0H2H9H11V2V6V10V12H9H2H0V10V2V0ZM11 6L12.6008 4.71938L14 3.6L16 2V4.56125V7.43875V10L14 8.4L12.6008 7.28062L11 6Z"
}));